import { Link, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PublicHeader from '@/components/layouts/PublicHeader'
import MobileAppBanner from '@/components/MobileAppBanner'
import StoreButtons from '@/components/StoreButtons'
import { HAS_APP_LINKS } from '@/config/appLinks'

export default function PublicLayout({ children }) {
  const { t } = useTranslation()
  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'var(--bg)', color: 'var(--ink)' }}>
      <MobileAppBanner />
      <PublicHeader />
      <div className="flex-1">
        {children ?? <Outlet />}
      </div>
      <footer className="flex flex-col items-center gap-4 py-6">
        {HAS_APP_LINKS && <StoreButtons size="sm" />}
        <Link to="/privacy" className="t-xs t-mut" style={{ color: 'inherit', textDecoration: 'none' }}>
          {t('footer.privacy', 'Maxfiylik siyosati')}
        </Link>
      </footer>
    </div>
  )
}
